import { all, concat, filter, find, includes, isEmpty, length, map, path, pathEq, prop, propEq, uniq, isNotNil, isNotEmpty } from 'ramda';
import DeleteWidgetsMutation from '../../../../_graphql/mutations/documents/DeleteWidgetsMutation';
import RemoveFoldersMutation from '../../../../_graphql/mutations/folders/RemoveFoldersMutation';
import { infoMessage } from '../../../../utils/messageMutation';

export function removeUnusedWidgets ({ widgets, folders, setIsOpen, setErrorRemoveWidgets, done }) {
  const widgetsIdUnused = map(prop('id'), filter((widget) => !prop('isUsed', widget))(widgets));
  infoMessage(`Suppression de ${length(widgetsIdUnused)} widgets inutilisés en cours, veuillez patienter...`);
  setIsOpen(true);
  DeleteWidgetsMutation({ widgetsIds: widgetsIdUnused }, (ok, error) => {
    if (ok && !error) {
      const folderElementsLinkedToUnusedWidgets = filter((folder) => includes(path(['element', 'elmId'], folder), widgetsIdUnused))(folders);
      const folderParentsLinkedToUnusedWidgets = filter((folder) => {
        const folderId = prop('id', folder);
        const isLinkedToAnElementToRemove = includes(folderId, map(prop('parent'), folderElementsLinkedToUnusedWidgets));
        if (isLinkedToAnElementToRemove) {
          const folderElementsLinkedToFolderParent = filter((folder) => {
            const isChild = pathEq(folderId, ['parent'], folder);
            if (isChild) {
              const isLinkedToUsedWidgets = !includes(path(['element', 'elmId'], folder), widgetsIdUnused);
              return isLinkedToUsedWidgets;
            }
            return false;
          })(folders);
          return isEmpty(folderElementsLinkedToFolderParent);
        }
        return false;
      })(folders);

      const getUnusedParentFolders = (foldersParent) =>
        ((foldersParent) =>
          map((id) => {
            const folder = find(propEq(id, 'id'))(folders);
            const foldersWithParent = filter((folder) => isNotNil(prop('parent', folder)))(folders);
            const children = filter(propEq(id, 'parent'))(foldersWithParent);
            const areAllChildrenUnused = all((child) => includes(prop('id', child), map(prop('id'), [...folderElementsLinkedToUnusedWidgets, ...folderParentsLinkedToUnusedWidgets])))(children);
            if (areAllChildrenUnused) {
              folderParentsLinkedToUnusedWidgets.push(folder);
              if (isNotNil(prop('parent', folder))) getUnusedParentFolders(foldersParent);
            }
          })(foldersParent))(
          uniq(map(prop('parent'), filter((folder) => isNotNil(prop('parent', folder)))(foldersParent)))
        );
      getUnusedParentFolders(folderParentsLinkedToUnusedWidgets);

      const foldersToRemove = concat(folderElementsLinkedToUnusedWidgets, folderParentsLinkedToUnusedWidgets);

      if (isNotEmpty(foldersToRemove)) {
        RemoveFoldersMutation({ foldersIds: map(prop('id'))(foldersToRemove) }, (ok, error) => {
          if (error) setErrorRemoveWidgets(true);
          done && done(ok, error);
        });
      } else {
        done && done(ok, error);
      }
    } else {
      setErrorRemoveWidgets(true);
      done && done(ok, error);
    }
  });
}
